<bootstrap-popup [id]="id" [title]="popupTitle" [displaySubject]="displaySubject">
	<form role="form" class="form-horizontal">
		<div class="row">
			<div class="col-md-12 coactivites">
				<p *ngFor="let coactivite of coactivites">
					<span>
						Acc&egrave;s
						{{ coactivite.acces.numero }} sur ouvrage
						{{ coactivite.acces.raisonConflit !== 'self' ? ' ' + coactivite.acces.raisonConflit : '' }} {{ coactivite.acces.commentaire }} 
						({{ coactivite.acces.typeAcces ? 'distant' : 'local' }})
						{{ coactivite.nomsOuvrages ? ' - ' + coactivite.nomsOuvrages : '' }}
						{{ coactivite.typeLabel ? ' - ' + coactivite.typeLabel : '' }}
					</span>
				</p>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<div class="form-group text-center">
					<button type="button" class="btn btn-success" *ngIf="isCac" 
						style="margin-right: 10px" (click)="onAuthorizeRequested()" >
						Autoriser l'acc&egrave;s
					</button>
					<button *ngIf="!isCac && isCc" type="button" class="btn btn-success" 
						style="margin-right: 10px" (click)="onValidationRequested()" >
						Demander une validation
					</button>
					<button
						type="button"
						class="btn btn-danger"
						style="margin-right: 6px"
						(click)="onDenyRequested()"
						>
						Refuser l'acc&egrave;s pour coactivit&eacute;
					</button>
					<button
						type="button"
						class="btn btn-primary"
						style="margin-right: 6px"
						(click)="onCancelRequested()"
						>
						Annuler
					</button>
				</div>
			</div>
		</div>
	</form>
</bootstrap-popup>